import { bool, cleanEnv, str, url } from "envalid";
const isProduction = process.env.NODE_ENV === "production";
/**
 * In production the auth config is fetched at runtime from the API
 * (see getAuthConfig) and URLs are derived from window.location
 * (see config/runtime.ts), so we skip build-time env validation.
 */ const env = isProduction ? {
    isProduction: true,
    AUTH_DOMAIN: "",
    AUTH_CLIENT_ID: "",
    AUTH_URL_PATH: "",
    AUTH_AUDIENCE: "",
    GATEWAY_URL: "",
    LOG_LEVEL: "info",
    LOG_ENABLED: true
} : cleanEnv(process.env, {
    AUTH_DOMAIN: str({
        default: ""
    }),
    AUTH_CLIENT_ID: str({
        default: ""
    }),
    AUTH_URL_PATH: str({
        default: ""
    }),
    AUTH_AUDIENCE: url({
        default: ""
    }),
    GATEWAY_URL: url({
        default: ""
    }),
    LOG_LEVEL: str({
        choices: [
            "fatal",
            "error",
            "warn",
            "info",
            "debug",
            "trace",
            "silent"
        ],
        default: "info"
    }),
    LOG_ENABLED: bool({
        default: true
    })
});
export { env };
